import Vue from 'vue';

const shared = Vue.observable({});

/**
 * Create a shared value.
 * @param key
 * @param value
 * @return {[{}, (function(*, *): *)]}
 * @example
 * const [shared, setShared] = useShared('count', 0);
 * setShared('count', 4);
 * console.log(shared.count); // return 4
 */
export default function useShared(key, value = null) {
    if (shared[ key ] === undefined) {
        shared[ key ] = value;
    }

    return [ shared, (key, newValue) => (shared[ key ] = newValue) ];
}
